import { Page, Event } from "@shapeable/gesda-types";

export type ExplorerView = 'ai' | 'user' | 'radar' | 'pulse-of-science' | 'community' | 'resources';
export type TrendView = 'radar-ai' | 'science';
export type TopicView = 'radar-ai' | 'overview' | 'connections' | 'resources' | 'contributors';
export type EventView = 'radar-ai' | 'key-takeaways' |'overview' | 'sessions' | 'resources';

/** Tab ids synced to #view=… (excludes radar-ai and other non-tab actions). */
export const TOPIC_CONTENT_TAB_VIEWS: TopicView[] = [
  'overview',
  'connections',
  'resources',
  'contributors',
];

export const EVENT_CONTENT_TAB_VIEWS: EventView[] = [
  'key-takeaways',
  'overview',
  'sessions',
  'resources',
];

export type LandmarkReport = Page & {
};

export type InvitedContribution = Page & {
};

export type SenseMaker = Page & {
};

export type Workshop = Event & {
};

const isPageType = (entity: Page, type: string) => {
  return entity.type?.slug === type || entity.types?.some(entityType => entityType.slug === type);
};

const isEventType = (entity: Event, type: string) => {
  return entity.type?.slug === type || entity.types?.[0]?.slug === type;
}

// type guards
export const isInvitedContribution = (value: Page): value is InvitedContribution => isPageType(value, 'invited-contribution');
export const isSenseMakingPage = (value: Page): value is SenseMaker => isPageType(value, 'sense-maker');
export const isWorkshopEvent = (value: Event): value is Workshop => isEventType(value, 'workshop');
export const isLandmarkReportPage = (value: Page): value is LandmarkReport => (
  isPageType(value, 'landmark-report') ||
  isPageType(value, 'deep-dive') ||
  isPageType(value, 'lens')
);

